import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router';
import {
    FaEye,
    FaEdit,
    FaTrash,
    FaUserTie,
    FaCheckCircle,
    FaTimesCircle,
    FaClock,
    FaUsers,
    FaUserPlus
} from 'react-icons/fa';
import { useDispatch } from "react-redux";
import { successToast, errorToast } from '../../Utils/toast';
import { openModal } from "../../redux/features/modalSlice";
import {
    useGetPendingSadasyaQuery,
    useUpdateSadasyaStatusMutation,
} from '../../redux/services/sadsayamember/sadsya.Services';
import CommonBreadcrumb from '../../common/CommonBreadcrumb';
function PendingMembers() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [search, setSearch] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [userRole, setUserRole] = useState('');
    const [userWaadId, setUserWaadId] = useState('');

    useEffect(() => {
        try {
            const role = localStorage.getItem('userRole');
            const waadId = localStorage.getItem('userWaadId');

            if (role) setUserRole(role);
            if (waadId) setUserWaadId(waadId);

            console.log("🔍 User Role from localStorage:", role);
            console.log("🔍 User Waad ID from localStorage:", waadId);
        } catch (error) {
            console.error("Error reading localStorage:", error);
        }
    }, []);

    const {
        data: pendingData,
        isLoading,
        isError,
        error,
        refetch
    } = useGetPendingSadasyaQuery(
        {
            waad_id: userWaadId,
            role: userRole
        }
    );

    const [updateSadasyaStatus, { isLoading: isUpdating }] = useUpdateSadasyaStatusMutation();

    const handleUpdateStatus = async (userId, status) => {
        try {
            await updateSadasyaStatus({ id: userId, status }).unwrap();
            successToast(`Sadasya ${status === 1 ? 'approved' : 'rejected'} successfully`);
            refetch();
        } catch (error) {
            errorToast(error?.data?.message || 'Failed to update status');
        }
    };

    const toggleUserSelection = (userId) => {
        setSelectedUsers(prev =>
            prev.includes(userId)
                ? prev.filter(id => id !== userId)
                : [...prev, userId]
        );
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedUsers(pendingData?.data?.map(u => u.id) || []);
        } else {
            setSelectedUsers([]);
        }
    };

    const handleBulkApprove = async () => {
        if (selectedUsers.length === 0) {
            errorToast('Please select at least one sadasya');
            return;
        }

        try {
            for (const userId of selectedUsers) {
                await updateSadasyaStatus({ id: userId, status: 1 }).unwrap();
            }
            successToast(`${selectedUsers.length} sadasya approved successfully`);
            setSelectedUsers([]);
            refetch();
        } catch (error) {
            errorToast(error?.data?.message || 'Bulk approval failed');
        }
    };

    const handleBulkReject = async () => {
        if (selectedUsers.length === 0) {
            errorToast('Please select at least one sadasya');
            return;
        }

        try {
            for (const userId of selectedUsers) {
                await updateSadasyaStatus({ id: userId, status: 2 }).unwrap();
            }
            successToast(`${selectedUsers.length} sadasya rejected successfully`);
            setSelectedUsers([]);
            refetch();
        } catch (error) {
            errorToast(error?.data?.message || 'Bulk rejection failed');
        }
    };

    const handleViewUser = (userId) => {
        navigate(`/sadasya-view/${userId}`);
    };

    const handleEditUser = (user) => {
        dispatch(
            openModal({
                type: "edit-sadasya-member",
                title: "Edit Sadasya Member",
                data: user
            })
        );
    };

    const handleDeleteUser = (user) => {
        dispatch(
            openModal({
                type: "delete-sadasya-member",
                title: "Delete Sadasya Member",
                data: user
            })
        );
    };

    // Filter data based on search
    const filteredData = pendingData?.data?.filter(user => {
        if (!search) return true;
        const searchLower = search.toLowerCase();
        return (
            user.name?.toLowerCase().includes(searchLower) ||
            user.mobile?.toLowerCase().includes(searchLower) ||
            user.email?.toLowerCase().includes(searchLower) ||
            user.sadasya_unique_id?.toLowerCase().includes(searchLower)
        );
    }) || [];

    // Loading state
    if (isLoading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    // Error state
    if (isError) {
        return (
            <div className="alert alert-danger m-3">
                Error: {error?.data?.message || 'Something went wrong'}
            </div>
        );
    }

    return (
        <div>

            {/* =============================================
                PAGE HEADER
                ============================================= */}
            {/* <div className="page-header-breadcrumb all_breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-semibold">
                            <FaClock className="me-2 text-warning" />
                            Pending Sadasya Members
                        </h4>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/sadasya-members">Sadasya Members</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Pending
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="page-title fw-semibold fs-18 mb-0">
                    <button
                        className="btn btn-warning"
                        onClick={() => refetch()}
                    >
                        <FaUsers className="me-2" />
                        Refresh
                    </button>
                </div>
            </div> */}
<CommonBreadcrumb
    title="Pending Sadasya Members"
    titleIcon={<FaClock className="me-2 text-warning" />}
    breadcrumbs={[
        { label: "Home", link: "/" },
        { label: "Sadasya Members", link: "/sadasya-members" },
        { label: "Pending" },
    ]}
    buttons={[
        {
            text: "Refresh",
            icon: <FaUsers className="me-2" />,
            onClick: refetch,
            className: "btn btn-primary",
        },
    ]}
/>
            {/* =============================================
                STATUS SUMMARY
                ============================================= */}
            <div className="card bg-warning bg-opacity-10 border-warning mb-4">
                <div className="card-body d-flex justify-content-between align-items-center">
                    <div>
                        <h5 className="mb-1">Total Pending Sadasya Members</h5>
                        <h2 className="mb-0">{pendingData?.count || 0}</h2>
                    </div>
                    <div className="bg-warning bg-opacity-25 p-4 rounded-circle">
                        <FaClock className="text-warning fs-1" />
                    </div>
                </div>
            </div>

            {/* =============================================
                SEARCH
                ============================================= */}
            <div className="card shadow-sm mb-4">
                <div className="card-body">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by name, mobile, email, ID..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>
                        <div className="col-md-6 text-end">
                            <button
                                className="btn btn-success me-2"
                                onClick={handleBulkApprove}
                                disabled={selectedUsers.length === 0 || isUpdating}
                            >
                                <FaCheckCircle className="me-2" />
                                Approve Selected ({selectedUsers.length})
                            </button>
                            <button
                                className="btn btn-danger"
                                onClick={handleBulkReject}
                                disabled={selectedUsers.length === 0 || isUpdating}
                            >
                                <FaTimesCircle className="me-2" />
                                Reject Selected ({selectedUsers.length})
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* =============================================
                TABLE
                ============================================= */}
            <div className="st-wrapper-card">
                <div className="st-table-responsive">
                    <table className="table st-custom-table align-middle mb-0">
                        <thead>
                            <tr>
                                <th style={{ width: '40px' }}>
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        onChange={handleSelectAll}
                                        checked={selectedUsers.length === filteredData.length && filteredData.length > 0}
                                    />
                                </th>
                                <th>#ID</th>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Email</th>
                                <th>Gotra</th>
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="text-center py-4">
                                        <div className="text-muted">
                                            <FaClock className="fs-2 d-block mx-auto mb-2" />
                                            No pending sadasya members found
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                filteredData.map((user) => (
                                    <tr key={user.id}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={selectedUsers.includes(user.id)}
                                                onChange={() => toggleUserSelection(user.id)}
                                            />
                                        </td>
                                        <td>#{user.id}</td>
                                        <td className="fw-semibold">{user.name}</td>
                                        <td>{user.mobile || '-'}</td>
                                        <td>{user.email || '-'}</td>
                                        <td>{user.self_gotra || '-'}</td>
                                        <td>
                                            <div className="d-flex justify-content-center gap-2">
                                                {/* Approve Button */}
                                                <button
                                                    className="btn btn-success btn-sm"
                                                    onClick={() => handleUpdateStatus(user.id, 1)}
                                                    disabled={isUpdating}
                                                    title="Approve"
                                                >
                                                    <FaCheckCircle />
                                                </button>

                                                {/* Reject Button */}
                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => handleUpdateStatus(user.id, 2)}
                                                    disabled={isUpdating}
                                                    title="Reject"
                                                >
                                                    <FaTimesCircle />
                                                </button>

                                                {/* View Button */}
                                                <button
                                                    className="st-action-btn st-view-btn"
                                                    onClick={() => handleViewUser(user.id)}
                                                    title="View Details"
                                                >
                                                    <FaEye />
                                                </button>
                                                 <Link
                                                    to={`/edit-user/${user.roles}/${user.id}`}
                                                    className="st-action-btn st-edit-btn"
                                                    title="Edit Member"
                                                >
                                                    <FaEdit />
                                                </Link>

                                                {/* Edit Button */}
                                                {/* <button
                                                    className="st-action-btn st-edit-btn"
                                                    onClick={() => handleEditUser(user)}
                                                    title="Edit Member"
                                                >
                                                    <FaEdit />
                                                </button> */}

                                                {/* Delete Button */}
                                                <button
                                                    className="st-action-btn st-delete-btn"
                                                    onClick={() => handleDeleteUser(user)}
                                                    title="Delete Member"
                                                >
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    );
}

export default PendingMembers;